<template>
    <div class="accordion" :class="{ 'is-opened': active }">
        <button type="button" class="accordion__head" @click="toggle">
            <slot name="head"></slot>
        </button>
        <TransitionExpand>
            <div v-show="active" class="accordion__inner">
                <div class="accordion__content">
                    <slot name="content"></slot>
                </div>
            </div>
        </TransitionExpand>
    </div>
</template>

<script>
import TransitionExpand from '@speechki-frontend/shared/ui/TransitionExpand';

export default {
    name: 'Accordion',
    components: {
        TransitionExpand
    },
    props: {
        itemId: {
            type: [Number, String]
        }
    },
    inject: {
        accordionState: {
            default: null
        }
    },
    data() {
        return {
            show: false
        };
    },
    computed: {
        active() {
            return (
                this.show || (this.accordionState && this.accordionState.activeItem === this.itemId)
            );
        }
    },
    watch: {
        show(val) {
            this.$emit(val ? 'expanded' : 'collapsed');
        }
    },
    methods: {
        toggle() {
            if (this.accordionState) {
                if (this.itemId === this.accordionState.activeItem) {
                    this.accordionState.activeItem = null;
                    return;
                }
                this.accordionState.activeItem = this.itemId;
            } else {
                this.show = !this.show;
            }
        }
    }
};
</script>

<style lang="scss" src="./Accordion.scss"></style>
